import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import gql from 'graphql-tag';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { NotaDebitoCabeceraComponent } from './nota-debito-cabecera/nota-debito-cabecera.component';
import { NotaDebitoDetallesComponent } from './nota-debito-detalles/nota-debito-detalles.component';
import * as _ from 'lodash'
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { DataCafService } from 'src/app/services/data-caf.service';

@Component({
  selector: 'app-nota-debito',
  templateUrl: './nota-debito.component.html',
  styleUrls: ['./nota-debito.component.scss'],
  providers: [SecurityService],
})
export class NotaDebitoComponent implements OnInit {

  // Modales
  @ViewChild(NotaDebitoCabeceraComponent, { static: true }) cabeceraComponent: NotaDebitoCabeceraComponent
  @ViewChild(NotaDebitoDetallesComponent, { static: true }) detallesComponent: NotaDebitoDetallesComponent
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent

  // optionsBodega: Array<any> = [];
  // optionsCondPago: Array<any> = [];
  // optionsListaPrecio: Array<any> = [];
  // optionsMedida: Array<any> = [];
  // optionsCategoria: Array<any> = [];
  // optionsFamilia: Array<any> = [];
  // optionsTipoTraslado: Array<any> = [];
  // optionsTipoEnvio: Array<any> = [];
  // dataCabecera: any = null
  // dataFooter: any = null

  processing: boolean = false
  codigos_dte: number[];

  // COUNT PARA LAS FACTURAS REALIZADAS
  contadorFacturas: number = 0;

  // Utils
  private log: any

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private dataCafService: DataCafService
  ) {
    this.log = this.clog.log('NOTA-DEBITO')

    // Seteamos los codigos DTE
    this.codigos_dte = [56];
    // Seteamos el valor del codigo DTE
    this.dataCafService.setDataCodigoDTE(56);
  }

  ngOnInit() {
  }

  public handleCabeceraChange(dataCabecera) {
    // this.dataCabecera = dataCabecera
    // this.detallesComponent.handleCabeceraChange(this.dataCabecera)
    this.detallesComponent.handleCabeceraChange(dataCabecera)
  }

  beginSave() {
    this.GuardarNotaDebito()
  }

  //Guardar Nota de Débito
  GuardarNotaDebito() {
    const isHeaderValid = this.cabeceraComponent.validate()
    if (!isHeaderValid) {
      this.toastrService.warning('Complete la información requerida')
      return
    }

    const headerData = this.cabeceraComponent.getHeaderData()
    const { dataCabecera, tipoNotaDebito, tipoCorreccionMonto, tipoAplicacion, rebajaStockDisable, fechaDocumento } = headerData
    this.log('headerData', headerData)
    if (!dataCabecera) {
      this.toastrService.warning('Complete la información requerida')
      return
    }

    const { cabecera: cabeceraOrigen, descuentosGlobales } = dataCabecera
    // const { additionalInfo } = cabeceraOrigen

    const detailsData = this.detallesComponent.getDetailsData()
    const { observaciones, glosa_administrativa, motivoGeneral, detalleDocumento: detalleDocumentoOrigen } = detailsData

    const sendDctosGlobales = (tipoNotaDebito === 2 && tipoCorreccionMonto === 10) || tipoNotaDebito === 3
    this.log('sendDctosGlobales', sendDctosGlobales)

    const folio = cabeceraOrigen.folio
    const fecha_emision = cabeceraOrigen.fecha_emision

    // Clone objects
    let cabecera = _.cloneDeep(cabeceraOrigen)
    let detalleDocumento = _.cloneDeep(detalleDocumentoOrigen)

    const esCorreccionDeMonto = cabecera.additionalInfo.esCorreccionDeMonto

    // Clear detalle
    detalleDocumento.map(detalle => {
      // delete detalle.additionalInfo // Lo eliminaré más abajo ya que lo necesito para unas validaciones
      if (detalle.atributos)
        detalle.atributos.map(attr => {
          delete attr.__typename
        })

      if (detalle.listaProductoFormato)
        detalle.listaProductoFormato.forEach((form) => {
          delete form.__typename;
        });
    })

    // Clear cabecera
    delete cabecera.additionalInfo
    delete cabecera.cliente_nombre
    delete cabecera.direccion_nombre
    delete cabecera.folio
    delete cabecera.tipo_devolucion_codigo
    delete cabecera.tipo_envio_codigo
    delete cabecera.tipo_traslado_codigo
    delete cabecera.vendedor_nombre

    // Set data
    cabecera.observaciones = observaciones

    cabecera.tipo_ncnd_codigo = tipoNotaDebito

    const inputParams: any = {
      entidadReferencia: {
        rut_emisor: cabecera.rut_emisor,
        tipo_dte_codigo: cabecera.tipo_dte_codigo,
        tipo_ncnd_codigo: cabecera.tipo_ncnd_codigo,
        folio, //: Number(headerData.nroDoc), // cabecera.folio
        fecha_emision,
      },
      entidad: {
        cabecera,
        descuentosGlobales: [],
        detalleDocumento
      }
    }

    // Set defaults
    inputParams.entidad.cabecera.fecha_emision = fechaDocumento
    inputParams.entidad.cabecera.glosa_administrativa = ''
    inputParams.entidad.cabecera.motivo_devolucion_codigo = 0
    inputParams.entidad.cabecera.aplica_rebaja = false
    inputParams.entidad.cabecera.es_correcion_monto = false

    // ADMINISTRATIVA
    if (tipoNotaDebito === 1) {
      inputParams.entidad.detalleDocumento = []
      inputParams.entidad.cabecera.glosa_administrativa = glosa_administrativa
      inputParams.entidad.cabecera.motivo_devolucion_codigo = motivoGeneral
      if (!this.validateAndHandleGlosaAdministativa(glosa_administrativa))
        return

      if (!this.validateAndHandleMotivoGeneral(motivoGeneral))
        return false
    }
    // POR CORRECCIÓN DE MONTO
    // else if (tipoNotaDebito === 2) {
    else if (esCorreccionDeMonto) {
      this.log('tipoCorreccionMonto', tipoCorreccionMonto)
      if (!this.validateAndHandleDetalles(detalleDocumento, false))
        return false

      // Acá el tratamiento es diferente a la NC
      inputParams.entidad.cabecera.es_correcion_monto = esCorreccionDeMonto
      inputParams.entidad.cabecera.aplica_rebaja = rebajaStockDisable
      inputParams.entidad.cabecera.motivo_devolucion_codigo = motivoGeneral

      if (!this.validateAndHandleMotivoGeneral(motivoGeneral))
        return false
    }
    // POR ANULACION
    else if (tipoNotaDebito === 3) {
      if (!this.validateAndHandleDetalles(detalleDocumento, false))
        return false

      // inputParams.entidad.cabecera.aplica_nota_debito = tipoAplicacion === 1 // No va en nota de débito
      inputParams.entidad.cabecera.motivo_devolucion_codigo = motivoGeneral
      if (!this.validateAndHandleMotivoGeneral(motivoGeneral))
        return false
      inputParams.entidad.cabecera.aplica_rebaja = rebajaStockDisable
      inputParams.entidad.descuentosGlobales = descuentosGlobales
    }

    // Validar motivo general en base a si está mostrado en pantalla
    if (dataCabecera.cabecera.additionalInfo.showMotivoGeneral)
      if (!this.validateAndHandleMotivoGeneral(motivoGeneral))
        return false

    // Lo elimino acá. Clear detalle->additionalInfo
    detalleDocumento.map(detalle => {
      delete detalle.additionalInfo // Lo eliminaré más abajo ya que lo necesito para unas validaciones
    })

    this.log('inputParams', JSON.stringify(inputParams))
    this.log('inputParams', inputParams)

    this.processing = true
    this.mutationGuardarNotaDebito(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.processing = false
        return
      }

      const { folio } = respuesta.cabecera
      this.toastrService.success(`Nota débito guardada con folio ${folio}`)
      this.processing = false
      this.CleanData()

      this.contadorFacturas++;

      return
    })
  }

  private CleanData() {
    this.cabeceraComponent.cleanData()
    this.detallesComponent.cleanData()
  }

  private validateAndHandleGlosaAdministativa(glosa) {
    if (!glosa || glosa.length === 0) {
      this.toastrService.warning('Ingrese glosa');
      return false
    }
    return true
  }

  private validateAndHandleDetalles(detalles, validateMotivo: boolean = true) {
    if (!detalles || detalles.length === 0) {
      this.toastrService.warning('Ingrese detalle')
      return false
    }

    // cantidades
    for (let i = 0; i < detalles.length; i++) {
      if (Number(detalles[i].cantidad) > Number(detalles[i].additionalInfo.cantidad)) {
        this.toastrService.warning('Existe una cantidad no válida')
        return false
      }
    }

    if (validateMotivo) {
      // for (let i = 0; i < detalles.length; i++) {
      //   if (!detalles[i].motivo_devolucion_especifico_codigo || detalles[i].motivo_devolucion_especifico_codigo === 0) {
      //     this.toastrService.warning('Ingrese motivo devolución específico')
      //     return false
      //   }
      // }
      const notValids = detalles.filter(detalle => !detalle.motivo_devolucion_especifico_codigo || detalle.motivo_devolucion_especifico_codigo === 0)
      if (notValids.length === detalles.length) {
        this.toastrService.warning('Ingrese al menos un motivo de devolución específico')
        return false
      }
    }

    // detalles.map(detalle => {
    //   if (!detalle.motivo_devolucion_especifico_codigo || detalle.motivo_devolucion_especifico_codigo === 0) {
    //     this.toastrService.warning('Ingrese motivo devolución específico')
    //     return false
    //   }
    // });
    return true
  }

  private validateAndHandleMotivoGeneral(motivoGeneral) {
    this.log('validateAndHandleMotivoGeneral', motivoGeneral)
    if (!motivoGeneral || motivoGeneral === 0 || motivoGeneral === '0') {
      this.toastrService.warning('Ingrese motivo devolución general')
      return false
    }
    return true
  }

  private mutationGuardarNotaDebito(inputParams, callback) {
    this.gqlclient.mutate(
      {
        mutation: gql`
        mutation ($entidad: documentoDTOInputType, $entidadReferencia: documentoInputType) {
          documento {
            guardarNotaDebito(entidad: $entidad, entidadReferencia: $entidadReferencia) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                cabecera {
                  rut_emisor
                  folio
                  tipo_dte_codigo
                  cliente_proveedor_rut
                  tipo_envio_codigo
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.guardarNotaDebito
        callback({ mensajes, respuesta })
      }
    );
  }


  clearFromButton() {
    this.modalConfirm.show(() => { this.CleanData() })
  }
}
